<!-- 渠道书库 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">渠道书库</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 12px 0 5px;">
			<!-- <div class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">作品名称</div>
				<a-input v-model="r_book_name" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">作品来源</div>
				<a-select
				    mode="multiple"
				    style="min-width: 180px"
				    placeholder="请选择作品来源"
				    @change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="1">阳光</a-select-option>
					<a-select-option value="2">文鼎</a-select-option>
					<a-select-option value="3">万读</a-select-option>
					<a-select-option value="4">阅文</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">作品频道</div>
				<a-select
				    mode="multiple"
				    style="min-width: 180px"
				    placeholder="请选择作品频道"
				    @change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
					<a-select-option value="0">未知</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">同步状态</div>
				<a-select
				    mode="multiple"
				    style="min-width: 180px"
				    placeholder="请选择同步状态"
				    @change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="0">未开始</a-select-option>
					<a-select-option value="1">进行中</a-select-option>
					<a-select-option value="2">已完成</a-select-option>
					<a-select-option value="3">失败</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">更新状态</div>
				<a-select
				    mode="multiple"
				    style="min-width: 180px"
				    placeholder="请选择更新状态"
				    @change="handleChangeE"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="0">连载中</a-select-option>
					<a-select-option value="1">已完结</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<a-button @click="goDownList" class="screen-box" type="primary">下载任务列表</a-button>
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[2].width + 'px'}" >
					{{rableTitle[2].title}}
				</div>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 2" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;min-height: 75px;">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 封面 -->
				<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					<img v-if="item.image" style="width: 80px;box-shadow: 0 0 6px 3px #ccc;" :src="item.image" alt="">
				</div>
				
				<!-- 作品名称 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					<div v-if="item.book_name" style="color: rgb(98, 168, 234);font-size: 15px;margin-bottom: 5px;">{{item.book_name}}</div>
					<div>作者：{{item.author}}</div>
				</div>
			</div>
			
			<!-- 来源 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.source}}
			</div>
			<!-- 分类 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				<div v-if="item.channel == '男频'" class="td-fl" style="background-color: #8950FC;">男频</div>
				<div v-if="item.channel == '女频'" class="td-fl" style="background-color: #F64E60;">女频</div>
				<br />
				<div v-if="item.category" class="td-fl" style="background-color: #3699FF;margin-top: 7px;">{{item.category}}</div>
			</div>
			<!-- 状态 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				<div v-if="item.is_finish == '连载中'" style="background-color: #1BC5BD;" class="td-fl">连载中</div>
				<div v-else-if="item.is_finish == '已完结'" style="background-color: #FFA800;" class="td-fl">已完结</div>
			</div>
			<!-- 字数 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.word_count}}
			</div>
			<!-- 同步状态 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.spd_status}}
			</div>
			<!-- 操作 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				<div @click="tdCz(item,1)" style="color: #62a8ea;cursor: pointer;margin-bottom: 7px;">设为投放作品</div>
				<div @click="tdCz(item,2)" style="color: #62a8ea;cursor: pointer;">全本下载</div>
			</div>
			<!-- 作品三方Id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				{{item.origin_id}}
			</div>
			<!-- 最后一章Id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[10].width + 'px'}">
				{{item.last_chapter_id}}
			</div>
			<!-- 创建时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[11].width + 'px'}">
				{{item.created_at}}
			</div>
			<!-- 更新时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[12].width + 'px'}">
				{{item.updated_at}}
			</div>
			
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;"> -->
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_scroll_width - 60 + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" hideOnSinglePage/>
			</div>
		<!-- </div> -->
	</div>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { libraryList, librarySetPutBook, libraryDownBook } from '@/request/api'
export default {
	name: 'libraryList_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"封面", width:110, type:"image", },
				{title:"作品名称", width:160, type:"book_name、author", },
				{title:"来源", width:100, type:"source", },
				{title:"分类", width:120, type:"channel、category", },
				{title:"状态", width:100, type:"is_finish", },
				{title:"字数", width:110, type:"word_count", },
				{title:"同步状态", width:110, type:"spd_status", },
				{title:"操作", width:120, type:"cz", },
				{title:"作品三方Id", width:180, type:"origin_id", },
				{title:"最后一章Id", width:120, type:"last_chapter_id", },
				{title:"创建时间", width:150, type:"created_at", },
				{title:"更新时间", width:150, type:"updated_at", },
				// {title:"操作", width:160, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			
			r_book_name: "", // 作品名称
			r_source: [], // 作品来源
			r_channel: [], // 作品频道
			r_spd_status: [], // 同步状态
			r_is_finish: [], // 更新状态
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		

		// 搜索
		that.searchButton()
			
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 作品来源
		handleChangeB(e){
			console.log(e);
			this.r_source = e
			
			this.searchButton('button')
		},
		// 作品频道
		handleChangeC(e){
			console.log(e);
			this.r_channel = e
			
			this.searchButton('button')
		},
		// 同步状态
		handleChangeD(e){
			this.r_spd_status = e
			
			this.searchButton('button')
		},
		// 更新状态
		handleChangeE(e){
			this.r_is_finish = e
			
			this.searchButton('button')
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			libraryList({
				limit: that.r_limit,
				page: that.r_page,
				
				book_name: that.r_book_name, // 作品名称
				source: that.r_source, // 作品来源
				channel: that.r_channel, // 作品频道
				spd_status: that.r_spd_status, // 同步状态
				is_finish: that.r_is_finish
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					
					
					// that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		
		// 表格内的操作
		tdCz(e,type){
			let that = this
			console.log(e);
			if(type == 1){ // 设为投放作品
				that.$confirm({
					title: '确认要设置为投放作品吗？',
					okText: "确认",
					cancelText: "取消", 
					onOk() {
						that.search_button_loading = true
						librarySetPutBook({
							id: e.id
						}).then(res=>{
							that.search_button_loading = false
							console.log('设置为投放作品',res);
							if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
								that.$message.success('设置成功');
							}
							else {
								if(res.data.code == 401){ // 未登录
									localStorage.removeItem("access_token");
									that.$router.replace({name: 'login',params: {type:'not_log'}})
								}
								else {
									that.$message.error(`错误：${res.data.msg}`);
								}
							}
						})
					},
					onCancel() {
					  console.log('Cancel');
					},
					class: 'test',
				});
			}
			else if(type == 2){ // 全本下载
				this.$confirm({
					title: '是否下载作品 ？',
					content: h => <div style="color:#ea5455;">下载结果请到 下载任务列表 查看</div>,
					okText: "确认",
					cancelText: "取消", 
					onOk() {
						that.search_button_loading = true
						libraryDownBook({
							id: e.id
						}).then(res=>{
							that.search_button_loading = false
							console.log('下载作品',res);
							if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
								that.$message.success('设置成功');
							}
							else {
								if(res.data.code == 401){ // 未登录
									localStorage.removeItem("access_token");
									that.$router.replace({name: 'login',params: {type:'not_log'}})
								}
								else {
									that.$message.error(`错误：${res.data.msg}`);
								}
							}
						})
					},
					onCancel() {
					  console.log('Cancel');
					},
					class: 'test',
				});
			}
		},
		// 前往下载任务列表
		goDownList(e){
			let that = this
			this.$router.push({path: '/libraryDown'})
		}
	}
	
}
</script>

<style scoped>
.td-fl {
	display: inline-block;
	padding: 3px 8px;
	color: #fff;
	text-align: center;
	/* line-height: 24px; */
	border-radius: 5px;
}
</style>